/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchresults1Inputs */

const en_searchresults1 = /** @type {(inputs: Searchresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Results`)
};

const de_searchresults1 = /** @type {(inputs: Searchresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchergebnisse`)
};

/**
* | output |
* | --- |
* | "Search Results" |
*
* @param {Searchresults1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchresults1 = /** @type {((inputs?: Searchresults1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchresults1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchresults1(inputs)
	return de_searchresults1(inputs)
});
export { searchresults1 as "searchResults" }